import { createFeatureSelector, createSelector } from '@ngrx/store';
import * as fromEmployeeMainReducer from '../employee-detail.reducer';
import { GenerateOtpState, generateOtpKey } from '../reducers/generate-otp.reducer';
import * as generateOtpState from '../reducers/generate-otp.reducer';

//#region Employee detail ROOT STATE
export const getMainEmployeeState = createFeatureSelector<fromEmployeeMainReducer.State, GenerateOtpState>(
  fromEmployeeMainReducer.employeeDetailFeatureKey
);
//#endregion

//#region Employee GenerateOtp SUB STATE
export const getGenerateOtpState = createSelector(getMainEmployeeState, state => state[generateOtpKey]);
//#endregion

//#region Employee GenerateOtp SUB STATE
export const getGenerateOtpRequest = createSelector(getGenerateOtpState, generateOtpState.getGenerateOtpRequest);
export const getGenerateOtpSuccess = createSelector(getGenerateOtpState, generateOtpState.getGenerateOtpResponse);
export const getGenerateOtpFailure = createSelector(getGenerateOtpState, generateOtpState.getGenerateOtpFailure);
//#endregion
